import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { Tween, Easing } from '@tweenjs/tween.js';

class SplashScreenController {
	constructor(vc, conf) {
		this.config = conf;
		if (vc) {
			this.vc = vc;
			this.btn = this.vc[this.config.btn].btn_holder.btn;
			this.btn.handler = this.handleClick.bind(this);
			this.checkBox = this.vc[this.config.checkbox];
			this.checkBox.cb.handler = this.update.bind(this);
			this.checkBox.cbtext.handler = this.update.bind(this);
			this.checkBox.cb.setActive(GameConfigs.settings.splash_screen);
			this.checkBox.cbtext.cursor = 'pointer';
			this.logo = this.vc.getChildByName('logo_img', true);
			// this.border = this.vc.getChildByName('splash_border_bot', true)
			this.enabled = true;
			this.initItems();
			this.addEventListeners();
			this.init();
		} else {
			throw new Error(
				'SplashScreenContriller failed init ' + JSON.stringify(this.config)
			);
		}
	}
	addEventListeners() {
		if (
			GameConfigs.settings.keyboard_shortcuts &&
			!window.isMobile &&
			!window.isTablet
		) {
			window.addEventListener('keydown', this, false);
		}
		window.addEventListener(EVENTS.ERROR_PAGE, this, false);
		window.addEventListener(EVENTS.SETTINGS_UPDATE, this, false);
	}

	handleClick() {
		if (this.enabled) {
			this.enabled = false;
			this.tweenerIcon = new Tween(this.btn.icon)
				.to({ rotation: 0.5 }, 50)
				.easing(Easing.Linear.None)
				.start();
			this.tweenerIconScale = new Tween(this.btn.icon.scale)
				.to({ x: 0.8, y: 0.8 }, 50)
				.easing(Easing.Linear.None)
				.start();
			this.tweener = new Tween(this.btn.scale)
				.to({ x: 0.8, y: 0.8 }, 50)
				.easing(Easing.Linear.None)
				.onComplete(() => {
					this.tweener = new Tween(this.btn.scale)
						.to({ x: 1, y: 1 }, 50)
						.easing(Easing.Linear.None)
						.start();
					this.tweenerIcon = new Tween(this.btn.icon)
						.to({ rotation: 0 }, 50)
						.easing(Easing.Linear.None)
						.start();
					this.tweenerIconScale = new Tween(this.btn.icon.scale)
						.to({ x: 1, y: 1 }, 50)
						.easing(Easing.Linear.None)
						.start()
						.onComplete(() => {
							HELPERS.dispatchCustomEvent(EVENTS.START_GAME, {});
							this.resetTweens();
							this.removeEvents();
						});
				})
				.start();
		}
	}

	resetTweens() {
		if (this.tweener) {
			this.tweener = null;
		}
		if (this.tweenerIcon) {
			this.tweenerIcon = null;
		}
		if (this.tweenerIconScale) {
			this.tweenerIconScale = null;
		}
	}

	handleEvent(evt) {
		switch (evt.type) {
			case 'keydown':
				if (evt.code === 'Space') {
					HELPERS.dispatchCustomEvent(EVENTS.START_GAME, { init: true });
					this.removeEvents();
				}
				break;
			case EVENTS.ERROR_PAGE:
				if (evt.detail.error) {
					this.removeEvents();
				}
				break;
			case EVENTS.START_GAME:
				this.removeEvents();
				break;
			default:
				break;
		}
	}

	initItems() {
		this.bonus_amount =
			this.vc.slider_bg.progressive_bonus_slide_2.progressive_bonus.bonus_item_3.text;
		this.bonus_mult =
			this.vc.slider_bg.progressive_bonus_slide_2.progressive_bonus.bonus_item_6.text;
		this.bonus_amount.text = '+' + GameConfigs.config.bonus_progress_half_spins;
		this.bonus_mult.text = GameConfigs.config.bonus_progress_end_mult + 'X';

		if (GameConfigs.config.bonus_progress_half_spins > 9) {
			this.bonus_amount.position.x = 35;
		} else {
			this.bonus_amount.position.x = 37;
		}
		if (GameConfigs.config.bonus_progress_end_mult > 9) {
			this.bonus_mult.position.x = 25;
		} else {
			this.bonus_mult.position.x = 37;
		}
		// this.border.anchor.set(1, 0.5);
		// this.border.rotation = 3.14159;
	}

	init() {
		this.checkBox.cb.bg.alpha = this.checkBox.cb.active ? 0 : 1;
		this.checkBox.cb.fg.alpha = this.checkBox.cb.active ? 1 : 0;
	}

	update() {
		this.checkBox.cb.active = !this.checkBox.cb.active;
		this.init();
		HELPERS.setSettings({
			splash_screen: this.checkBox.cb.active
		});
	}

	resize(w, h) {
		if (window.isMobile || window.isTablet) {
			if (w < h) {
				this.btn.position.x = 140;
				this.logo.position.x = 0;
			} else {
				this.btn.position.x = 45;
				this.logo.position.x = -60;
			}
		} else {
			this.btn.position.x = 45;
			this.logo.position.x = -60;
		}
	}

	removeEvents() {
		this.btn.interactive = false;
		this.checkBox.cb.interactive = false;
		this.checkBox.cbtext.interactive = false;
		window.removeEventListener('keydown', this, false);
		window.removeEventListener(EVENTS.ERROR_PAGE, this, false);
		window.removeEventListener(EVENTS.SETTINGS_UPDATE, this, false);
	}
}
export default SplashScreenController;
